/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, September 2022
 *
 *****************************************************************************/

/**
 * This is a constant padding file, all the padding used in webapp are rest here
 */

export const PADDING = {
  PADDING_ZERO: "0px",
  PADDING_TWO: "2px",
  PADDING_FOUR: "4px",
  PADDING_EIGHT: "8px",
  PADDING_TWELVE: "12px",
  PADDING_SIXTEEN: "16px",
  PADDING_TWENTY: "20px",
  PADDING_TWENTY_FOUR: "24px",
  PADDING_TWENTY_EIGHT: "28px",
  PADDING_THIRTY_TWO: "32px",
  PADDING_THIRTY_SIX: "36px",
  PADDING_FORTY: "40px",
  PADDING_FORTY_FOUR: "44px",
  PADDING_FORTY_EIGHT: "48px",
  PADDING_FIFTY_TWO: "52px",
  PADDING_FIFTY_SIX: "56px",
  PADDING_SIXTY: "60px",
};
